import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: 'app-eca-modal-host',
  templateUrl: './eca-modal-host.component.html',
  styleUrls: ['./eca-modal-host.component.scss']
})

export class EcaModalHostComponent implements OnInit {
  @Input() heading: string;
  @Input() yesButtonText = 'Save';
  @Input() saveAndUploadButtonText = 'Save & Upload Document';
  @Input() editButtonText = 'Edit';
  @Input() closeButtonText = 'Close';
  @Input() noButtonText = 'Cancel';
  @Input() yesButtonColour = 'success';
  @Input() editButtonColour = 'primary';
  @Input() closeButtonColour = 'warning';
  @Input() noButtonColour = 'danger';
  @Input() yesButtonIcon: any = null;
  @Input() noButtonIcon: any = null;
  @Input() closeButtonIcon: any = ['far', 'times'];
  @Input() isEditing: boolean = false;
  @Input() showSaveAndUploadButton: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() buttonsDisabled: boolean = false;
  @Input() editButtonIcon: any = null;
  @Input() showExportToPDFButton: boolean = false;
  @Input() printClicked: boolean = false;
  printIcon: any = ['far', 'print'];
  showSaveAndUploadButtonIcon: any = ['far', 'file-upload'];

  @Output() saveClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saveAndUploadClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() helpClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  showSaveAndUploadButtonColor = 'success';

  constructor(public modalRef: DynamicDialogRef) { }

  ngOnInit() {

  }
  saveAndUploadBtnClicked() {
    this.saveAndUploadClicked.emit();
  }

  clicked(answer: boolean) {
    this.saveClicked.emit(answer);
  }

  editBtnClicked() {
    this.editClicked.emit(true);
    if (this.yesButtonIcon || this.yesButtonText)
      this.isEditing = true;
  }

  cancelBtnClicked() {
    this.cancelClicked.emit(true);
  }

  helpBtnClicked() {
    this.helpClicked.emit(true);
  }

  closeBtnClicked() {
    this.modalRef.close();
    this.cancelClicked.emit();
  }
}
